import { render, staticRenderFns } from "./dialogPop.vue?vue&type=template&id=4a2bb012&scoped=true&"
import script from "./dialogPop.vue?vue&type=script&lang=js&"
export * from "./dialogPop.vue?vue&type=script&lang=js&"
import style0 from "./dialogPop.vue?vue&type=style&index=0&id=4a2bb012&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2bb012",
  null
  
)

export default component.exports